import {AssetsTranslations, TranslationsMap} from "../CountryPage";

import firstSectionMobile from "../../../assets/images/ENG/first-section-mobile_ENG.jpg";
import firstSectionDesktop from "../../../assets/images/ENG/first-section-desktop_ENG.jpg";
import secondSectionMobile from "../../../assets/images/ENG/second-section-mobile_ENG.jpg";
import secondSectionDesktop from "../../../assets/images/ENG/second-section-desktop_ENG.jpg";
import thirdSectionMobile from "../../../assets/images/ENG/third-section-mobile_ENG.jpg";
import thirdSectionDesktop from "../../../assets/images/ENG/third-section-desktop_ENG.jpg";
import fourthSectionMobile from "../../../assets/images/ENG/fourth-section-mobile_ENG.jpg";
import fourthSectionDesktop from "../../../assets/images/ENG/fourth-section-desktop_ENG.jpg";


export const englishTranslatedAssets : AssetsTranslations = {
  firstSectionMobile,
  firstSectionDesktop,
  secondSectionMobile,
  secondSectionDesktop,
  thirdSectionMobile,
  thirdSectionDesktop,
  fourthSectionMobile,
  fourthSectionDesktop
}

export const englishTranslations : TranslationsMap = {
  "landingPage.selection.title": "Welcome to Cora BC",
  "landingPage.selection.body": "To read information about the product, choose the country of your residency below:​",
  "landingPage.hero.title": "Your support in life with breast cancer",
  "landingPage.hero.body": "Understand and manage your breast cancer to help you in leading a more confident and informed life.",
  "landingPage.hero.preLaunch.cta": "Sign up",
  "landingPage.hero.sponsored": "Developed by Dawn Health with support from Novartis Pharma AG",
  "landingPage.usp.ho.label": "Health overview",
  "landingPage.usp.ho.title": "Manage your health changes",
  "landingPage.usp.ho.body": "Log your experiences on a regular basis to observe any changes in your health. Feel more in control and informed about your breast cancer history through insightful graphs.",
  "landingPage.usp.ia.label": "Supporting adherence",
  "landingPage.usp.ia.title": "Stay on track with your treatment",
  "landingPage.usp.ia.body": "Get support with your new routine by maintaining your complex medication schedules in one place.",
  "landingPage.usp.si.label": "Stay informed",
  "landingPage.usp.si.title": "Get content, just for you",
  "landingPage.usp.si.body": "Receive recommended articles that may help you with your personal experience, and access them anytime and anywhere. Learn at your own pace and spend extra time on the topics you find most important.",
  "landingPage.usp.cs.label": "Consultation support",
  "landingPage.usp.cs.title": "Be empowered in your care",
  "landingPage.usp.cs.body": "Maintain all of your upcoming appointments in Cora. Feel prepared to actively take part in conversations with your doctor by writing notes using our topic prompts.",
  "landingPage.moreFeatures.title": "...more features and benefits of Cora BC",
  "landingPage.moreFeatures.feel.title": "Feel empowered through preparation",
  "landingPage.moreFeatures.feel.body": "Note down relevant information and questions you want to ask, so that you can be prepared to cover all the important topics at consultations.",
  "landingPage.moreFeatures.discover.title": "Discover an intuitive and easy-to-use design",
  "landingPage.moreFeatures.discover.body": "Experience an intuitive and user-friendly interface that’s easy to navigate.​",
  "landingPage.moreFeatures.tools.title": "Tools to help you feel more organised in everyday life​",
  "landingPage.moreFeatures.tools.body": "Customise your notifications to a schedule that suits you best​.",
  "landingPage.signUp.label": "Upcoming app release",
  "landingPage.signUp.title": "Sign up to be notified",
  "landingPage.signUp.body": "Cora BC is being released in December 2024. Sign up with your email to be notified when the app is ready for download.",
  "landingPage.signUp.input.placeholder": "Input email here",
  "landingPage.signUp.button": "Sign up",
  "landingPage.signUp.disclaimer": "By submitting your email you agree to receive information about the Cora BC product.",
  "landingPage.signUp.complete.title": "Your email has been submitted",
  "landingPage.signUp.complete.body": "Thank you for submitting your email. You will receive an email when Cora BC is available for you to download.",
  "landingPage.footer.privacyPolicy": "Privacy policy",
  "landingPage.download.title": "Download Cora BC",
  "landingPage.download.body": "Your support in life with breast cancer. Download for free now.",
  "landingPage.topBar.label": "Coming in December 2024",
  "landingPage.topBar.body": "Sign up to be notified of release",
  "landingPage.topBar.button": "Sign up",
  "landingPage.companionApp": "Companion app",
  "landingPage.coraBC": "Cora BC",
  "landingPage.mobile.countrySelection.australia": "Australia (Not in scope for now)",
  "landingPage.mobile.preLaunch.productInformation.signUp": "Sign up for release",
  "mobile.preLaunch.productInformation.upcomingRelease": "Upcoming release",
  "landingPage.mobile.preLaunch.productInformation.sponsor": "Cora BC (UK) has been sponsored by \nNovartis Pharmaceuticals UK Ltd.",
  "landingPage.usp.ia.label.9": "Supporting Adherence",
  "landingPage.PrivacyPolicy": "Privacy Policy",
  "landingPage.back": "Back",
  "landingPage.mobile.postLaunch.productInformation.appStore": "App Store",
  "landingPage.mobile.postLaunch.productInformation.googlePlay": "Google Play"
}